import React from 'react';
import rana from '../Images/round-gradient-designify.png';

const About = () => {
    return (
        <div className='m' id='aboutme' >
            <h1 className='text-3xl font-bold text-center uppercase text-orange-400'>About me</h1>

            <div className='grid grid-cols-1 lg:grid-cols-2 gap-5'>
                <div className='' >
                    <img src={rana} alt="" data-aos="fade-up"
     data-aos-easing="ease-out-cubic"
     data-aos-duration="2000"/>
                </div>

                <div className='flex items-center'data-aos="fade-up"
     data-aos-easing="ease-out-cubic"
     data-aos-duration="2000">
                    <p className=' text-lg font-bold text-justify'>This is <span className='text-xl font-bold text-rose-400'>Tauhidur Rahman Rana</span>. I have completed my Bachelor in Computer Science & Engineering in 2017 from Leading University. From the beginnig of my career, I was a Network & Support Engineer of a reputed group of company but now i want to build my career as a full stack web developer and i have deep interest in React.js and other fontEnd technologies. Now I am ready to hire as a FrontEnd/React.js developer.</p>
                </div>
            </div>
        </div>
    );
};

export default About;